export type DimensionFilterState = {
  country: string;
  language: string;
  device_type: string;
};

export const emptyDimensionFilters = (): DimensionFilterState => ({
  country: '',
  language: '',
  device_type: '',
});

export function applyDimensionFilters<T>(params: T, filters: DimensionFilterState): T {
  const country = filters.country.trim();
  const language = filters.language.trim();
  const deviceType = filters.device_type.trim();
  const target = params as T & {
    country?: string;
    language?: string;
    device_type?: string;
  };
  if (country) target.country = country;
  if (language) target.language = language;
  if (deviceType) target.device_type = deviceType;
  return params;
}
